import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveFitnessGoal } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import SingleSelect from '../../../components/single-select';

const selectOptions = [
  {
    optionText: 'Lose weight',
    optionValue: 'weightloss'
  },
  {
    optionText: 'Build muscle',
    optionValue: 'strengthandpower'
  },
  {
    optionText: 'Tone and sculpt',
    optionValue: 'leanandtone'
  },
  {
    optionText: 'Maintain',
    optionValue: 'happyandhealthy'
  }
];

export class PureFitnessGoalPage extends Component {
  constructor(props) {
    super(props);

    this.state = { fitnessGoal: props.initialValue };
  }

  save = async () => {
    try {
      await this.props.saveFitnessGoal(this.state.fitnessGoal);
    } catch (e) {
      /* do nothing */
    }
  }

  onSelect = (selectOption) => {
    const fitnessGoal = selectOption === null ? '' : selectOptions[selectOption].optionValue;
    this.setState({ fitnessGoal });
  }

  getActiveOption = () => {
    return selectOptions.findIndex((el) => {
      return el.optionValue === this.state.fitnessGoal;
    });
  }

  render() {
    return (
      <SettingsContainer
        className="fitness-goal-page"
        pageTitle="What's your main fitness goal?"
        save={ this.save }
        isValid={ Boolean(this.state.fitnessGoal) }
      >
        <SingleSelect
          selectOptions={ selectOptions }
          value={ this.getActiveOption() }
          onSelect={ this.onSelect }
        />
      </SettingsContainer>
    );
  }
}

PureFitnessGoalPage.propTypes = {
  initialValue: PropTypes.string.isRequired,
  saveFitnessGoal: PropTypes.func.isRequired
};

PureFitnessGoalPage.defaultProps = {
  initialValue: ''
};

export default connect(
  state => ({
    initialValue: state.user.fitness_goal // eslint-disable-line camelcase
  }),
  dispatch => ({
    saveFitnessGoal: fitnessGoal => dispatch(saveFitnessGoal(fitnessGoal))
  }),
  null,
  { withRef: true }
)(PureFitnessGoalPage);
